/**
 * Backend `LocalizedJSONField` values arrive either as a language map
 * (`{ en: '…', ro: '…' }`) or as a bare string (legacy rows, or endpoints
 * that resolve the language server-side). The generated SDK types omit these
 * fields entirely, so consumers declare them with this shape.
 */
export type LocalizedField = Record<string, string> | string | null | undefined

/** Reduce a localized field to the active language with an `en` fallback. */
export const readLocalized = (
  value: LocalizedField,
  lang: string,
  fallback = ''
): string => {
  if (!value) return fallback
  if (typeof value === 'string') return value
  return value[lang] ?? value.en ?? Object.values(value)[0] ?? fallback
}

/**
 * The backend's `LocalizedRawJSONField` only accepts short Django codes
 * (`en`, `ro`, `ru`); i18next exposes `language` as `en-US`, so strip the
 * region suffix before round-tripping.
 */
export const toBaseLang = (lang?: string): string =>
  (lang || 'en').toLowerCase().split(/[-_]/)[0]
